import { useEffect, useState, ReactNode } from 'react';

const NUMBER_DISPLAY_POPOVER_KEY = 'mp:listing-header-experiment-popover';
const MAX_NUMBER_OF_DISPLAYS = 1;

let ExperimentPopOver: () => ReactNode | undefined;

const useExperimentPopOver = () => {
  const [isPopOverLoaded, setIsPopOverLoaded] = useState(false);

  useEffect(() => {
    const storedCount = window.localStorage.getItem(NUMBER_DISPLAY_POPOVER_KEY);
    const showCount = storedCount ? (JSON.parse(storedCount) as number) : 0;

    if (showCount < MAX_NUMBER_OF_DISPLAYS) {
      if (!isPopOverLoaded) {
        const loadComponent = async () => {
          try {
            ExperimentPopOver = (
              await import(/* webpackChunkName: "experimentPopOver" */ '../ExperimentPopover/ExperimentPopOver')
            ).default;
          } catch (err) {
            return;
          }
        };

        loadComponent();
        setIsPopOverLoaded(true);
      }
      window.localStorage.setItem(NUMBER_DISPLAY_POPOVER_KEY, JSON.stringify(showCount + 1));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Effect only needed on first run

  return { ExperimentPopOver };
};

export default useExperimentPopOver;
